import { z } from "zod";

import { auditEventMinimalSchema } from "./audit-event-minimal";

export const auditEventBaseSchema = auditEventMinimalSchema.extend({
	auditType: z.never(),
	alias: z.string(),
	data: z.any(),
});

export type AuditEventBase = z.infer<typeof auditEventBaseSchema>;
